import { Component, OnInit,Input,ViewEncapsulation } from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {debounceTime, distinctUntilChanged, map} from 'rxjs/operators';
import {Observable} from 'rxjs';
import { isString } from 'util';
@Component({
  selector: 'select-country',
  templateUrl: './select-country.component.html',
  styleUrls: ['./select-country.component.scss'],encapsulation: ViewEncapsulation.None
})

export class SelectCountryComponent implements OnInit {
  constructor(public activeModal: NgbActiveModal) { }


  @Input() countries;
country:any="";
  ngOnInit(){
   // this.getCountries();
  
   
   

   
  }
getCountries(){
 
}


  passBack() {
   
    this.activeModal.close({mission:this.country,category:parseInt(this.country.MC_Category)});
    }

}



// WEBPACK FOOTER //
// ./src/app/select-country/select-country.component.ts